export default {
  call_action: {}
}
